var map = {
	"./accident.wav": "a0b7",
	"./adult.wav": "399e",
	"./angel.wav": "3adb",
	"./apricot.wav": "9fe6",
	"./belive.wav": "62af",
	"./brother.wav": "8fd6",
	"./cottonwool.wav": "add1",
	"./eight.wav": "330b",
	"./eye.wav": "9e4d",
	"./fidelity.wav": "6d8e",
	"./glair.wav": "2b69",
	"./guest.wav": "3f33",
	"./hot.wav": "bf06",
	"./top.wav": "5ca3",
	"./twirl.wav": "5d12",
	"./water.wav": "e919",
	"./weighingmachine.wav": "7e83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7161";